import React from "react";
import {Typography} from '@mui/material';
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";

import NavigationButton from "../NavigationButton";

const styles = {
    sectionHeader: {
        fontSize: '0.7rem'
    }
};

export default function AdminMenuSnippet({permissions}) {
    if (!permissions.canAdmin) {
        return null;
    }

    return (
        <>
            <Typography variant="overline" sx={styles.sectionHeader}>Admin</Typography>
            <NavigationButton displayName="Tag Manager" toLink="/tag-manager">
                <LocalOfferIcon/>
            </NavigationButton>
            <NavigationButton displayName="Users" toLink="/users">
                <PeopleAltIcon/>
            </NavigationButton>
        </>
    );
}
